export default __webpack_public_path__ + "static/media/notifications-30days.91c460ec.svg";